import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncSolarIconBroken = createAsyncIcon(() => import('./SolarIconBroken'));

export default AsyncSolarIconBroken;

AsyncSolarIconBroken.displayName = 'AsyncSolarIconBroken';
